import React, {Component} from 'react';
import '../scss/App.scss';
import $ from 'jquery';
import 'foundation-sites';
import {Login, LoginCallback, Logout, RouteWithAuthorization} from "@spins-gcp/auth0-react";
import {Route, Routes} from "react-router-dom";
import {ROUTES} from "../routes.js";
import {Header} from "./header/Header.jsx";
import {ApolloProvider} from "@apollo/client";
import {createApolloClient} from "../api/createApolloClient.js";

class Dashboard extends Component {

    async componentDidMount() {
        $(document).foundation();
    }

    render() {
        return (
            <ApolloProvider client={createApolloClient()}>
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/loginCallback" element={<LoginCallback/>}/>
                    <Route path="/logout" element={<Logout/>}/>
                    <Route path="/unauthorized" element={<div>Unauthorized</div>}/>
                    {
                        ROUTES.map(({path, Component}) => {
                            return <Route key={path} path={path} element={
                                <RouteWithAuthorization><Header/><Component/></RouteWithAuthorization>
                            }/>;
                        })
                    }
                </Routes>
            </ApolloProvider>
        );
    }
}

export default Dashboard;
